import React, { Component } from 'react';
import { connect } from 'react-redux';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import If from '../../helper/component/If';

function mapStateToProps(state) {
  return {
    data: state.formDataReducer,
  };
}

var r, g, b, hsp;
const lightOrDark = (color) => {
  // Check the format of the color, HEX or RGB?
  if (color.match(/^rgb/)) {
    // If HEX --> store the red, green, blue values in separate variables
    color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
    r = color[1];
    g = color[2];
    b = color[3];
  }
  else {
    // If RGB --> Convert it to HEX: http://gist.github.com/983661
    color = +("0x" + color.slice(1).replace(
      color.length < 5 && /./g, '$&$&'
    )
    );
    r = color >> 16;
    g = color >> 8 & 255;
    b = color & 255;
  }
  // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
  hsp = Math.sqrt(
    0.299 * (r * r) +
    0.587 * (g * g) +
    0.114 * (b * b)
  );
  // Using the HSP value, determine whether the color is light or dark
  if (hsp > 127.5) {
    return '#000';

  }
  else {
    return '#fff';
  }
}
const getInitials = (name) => {
  if (name) {
    var array = name.toString().split(" ");
    switch (array.length) {
      case 0:
        return "#";
      case 1:
        return array[0].charAt(0).toUpperCase();
      default:
        return array[0].charAt(0).toUpperCase() + array[1].charAt(0).toUpperCase();
    }
  } else {
    return name;
  }
}
class Workflow extends Component {
  constructor() {
    super();
    this.state = {

    }
  }
  componentDidMount() {
    debugger;
  }

  getColor(control, item) {
    var status = item[control.statusfield];

    var colorObj = Array.isArray(control.statusColor) ? control.statusColor.find(x => x.status === status) : null;

    return colorObj ? colorObj.color : '';
  }
  getIcon(control, item) {
    var status = item[control.statusfield];

    var iconObj = Array.isArray(control.statusColor) ? control.statusColor.find(x => x.status === status) : null;

    return iconObj ? iconObj.icon : '';
  }
  render() {
    const { control, formid } = this.props;
    var data = this.props.data[formid] && Array.isArray(this.props.data[formid][control.key]) ? this.props.data[formid][control.key] : control.data ? JSON.parse(control.data) : [];
    // data = [{ "status": "Complete", "Title": "Task1" }, { "status": "InProgress", "Title": "Task2" }, { "status": "Complete", "Title": "Task3" }, { "status": "Pending", "Title": "Task4" }, { "status": "Complete", "Title": "Task5" }, { "status": "InProgress", "Title": "Task6" }, { "status": "Pending", "Title": "Task7" }];

    var result = data.map((item, index) => {
      return (
        <OverlayTrigger overlay={<Tooltip id={item.id}>{item[control.statusfield]}</Tooltip>}>
          <li data-step={index + 1} style={{width:(100/data.length)+'%'}}>
            <span className={'stap-no'} style={{ background: this.getColor(control, item) }}>
              <If show={this.getIcon(control, item)}>
                <i className={"fa fa-lg fa-" + this.getIcon(control, item)} style={{ color: lightOrDark(this.getColor(control, item)) }}></i>
              </If>
              <If show={!this.getIcon(control, item)}>
                <span style={{ color: lightOrDark(this.getColor(control, item)) }}>{getInitials(item[control.statusfield])}</span>
              </If>
            </span>
            <button className={"pointer btn-no "} onClick={(e)=>{e.preventDefault();}} data-toggle="tab" role="tab">
              <span className="d-block text-center">{item[control.taskfield]}</span>
            </button>
            <span className="line" style={{backgroundColor:control.arrowcolor}}></span>
          </li>
        </OverlayTrigger>
      )
    });
    return (
      <div className={"mb-3  workflow "}>
        <ul className={"d-flex justify-content-between wizard-ul"} role="tablist">
          {result}
        </ul>
      </div>
    )
  }
}

export default connect(
  mapStateToProps,
)(Workflow);